export enum ETransactionItemType {
  FIREARM = 'FIREARM',
  ANCILLARY = 'ANCILLARY',
}
